import { Collapse, Divider, Stack, Typography } from "@mui/material"
import { ReactElement } from "react"
import { Control, FieldValues } from "react-hook-form"

import { DNO_WORKS_REQUIRED_REASON_REG } from "./dnoResponseForm"
import { DnoWorksRequiredReasons } from "../../../constants/enums"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import ValidatedCheckBox from "../../inputs/validated/validatedCheckBox"

const DNO_WORKS_REQUIRED_REASONS = Object.fromEntries(
    Object.values(DnoWorksRequiredReasons).map((v) => [v, v])
)

interface IDnoWorksRequiredReasonsSection<T extends FieldValues = FieldValues> {
    display: boolean
    control: Control<T>
}

/**
 * Displays the reasons for a DNO Works Required response. Allows the DNO
 * user to select one or more reasons why works are required before the
 * proposed devices can be connected.
 */
const DnoWorksRequiredReasonsSection = <T extends FieldValues = FieldValues>({
    display,
    control,
}: IDnoWorksRequiredReasonsSection<T>): ReactElement => (
    <Collapse in={display}>
        <Stack spacing={GRID_SPACING} marginY={1}>
            <Typography color="text.secondary">
                Please select the reason(s) why DNO works are required
            </Typography>
            <ValidatedCheckBox
                control={control as unknown as Control<FieldValues>}
                required={false}
                registerName={DNO_WORKS_REQUIRED_REASON_REG}
                label="Reasons works are required"
                checkboxOptions={DNO_WORKS_REQUIRED_REASONS}
            />
            <Divider />
        </Stack>
    </Collapse>
)

export default DnoWorksRequiredReasonsSection
